import { useEffect, useState } from "react";
import { loadImageAsync } from "./utils";

export const useImages = (srcList: (string | undefined)[]) => {
  const [dataUrls, setDataUrls] = useState<(string | undefined)[]>([]);

  useEffect(() => {
    Promise.all(
      srcList.map((imageSrc) => {
        if (imageSrc) {
          try {
            return loadImageAsync(imageSrc);
          } catch {
            return undefined;
          }
        } else {
          return undefined;
        }
      })
    ).then((urls) => setDataUrls(urls));
  }, [srcList]);

  return dataUrls;
};
